import type { RootState } from "../store";

export interface CategoryBetaParams {
  locationName?: string;
  roleId?: number;
}

/**
 * Beta-rollout query params for GET /ticketing/form-config and
 * GET /ticketing/form-config/categories. Axios drops undefined values and
 * URL-encodes the rest.
 */
export const getCategoryBetaParams = (state: RootState): CategoryBetaParams => {
  const appData = (state as any).appData;
  const locationName = String(appData?.selectedLocation?.name ?? "").trim();
  const rawRoleId = appData?.userInfo?.roleId;
  const roleId = rawRoleId == null || rawRoleId === "" ? NaN : Number(rawRoleId);

  return {
    locationName: locationName || undefined,
    roleId: Number.isFinite(roleId) ? roleId : undefined,
  };
};

/** Cache key for the category tree: it depends on both location and role. */
export const getCategoryBetaKey = ({ locationName, roleId }: CategoryBetaParams): string =>
  `${(locationName ?? "").toLowerCase()}|${roleId ?? ""}`;

/** True when the cached category tree is missing or was fetched for another location/role. */
export const isCategoryConfigStale = (state: RootState): boolean => {
  const { submitTicketCategoryConfig, submitTicketCategoryConfigKey } = state.ticketingPortal;
  return (
    !submitTicketCategoryConfig.length ||
    submitTicketCategoryConfigKey !== getCategoryBetaKey(getCategoryBetaParams(state))
  );
};
